export default __webpack_public_path__ + "static/media/instagramIcon.162760cd.svg";